// Helpers for the content/SEO override system.
const isPlainObj = (v) => v && typeof v === "object" && !Array.isArray(v);

// Deep-merge override values over the base translations.
// - never overrides function values (templates stay intact)
// - merges arrays by index
// - allows override-only branches (e.g. "_seo") that don't exist in base
export function deepMerge(base, ov) {
  if (ov == null) return base;
  if (Array.isArray(base)) {
    return base.map((item, i) => {
      const o = ov[i];
      if (o === undefined || o === null) return item;
      if (isPlainObj(item) || Array.isArray(item)) return deepMerge(item, o);
      return typeof o === typeof item ? o : item;
    });
  }
  if (isPlainObj(base)) {
    const result = { ...base };
    Object.keys(ov).forEach((k) => {
      if (k in base) {
        const bv = base[k];
        if (typeof bv === "function") return; // never override templates
        if (isPlainObj(bv) || Array.isArray(bv)) result[k] = deepMerge(bv, ov[k]);
        else if (ov[k] !== undefined && ov[k] !== null && ov[k] !== "") result[k] = ov[k];
      } else {
        result[k] = ov[k]; // e.g. _seo namespace
      }
    });
    return result;
  }
  return ov;
}

// Flatten all string leaves to { path, value } for the text editor.
export function flattenStrings(obj, prefix = "") {
  const out = [];
  const walk = (val, path) => {
    if (typeof val === "string") { out.push({ path, value: val }); return; }
    if (Array.isArray(val)) { val.forEach((v, i) => walk(v, `${path}.${i}`)); return; }
    if (isPlainObj(val)) { Object.keys(val).forEach((k) => walk(val[k], path ? `${path}.${k}` : k)); return; }
  };
  walk(obj, prefix);
  return out;
}

export function getByPath(root, path) {
  return String(path).split(".").reduce((n, k) => (n == null ? undefined : n[k]), root);
}

export function setByPath(root, path, value) {
  const parts = String(path).split(".");
  let node = root;
  for (let i = 0; i < parts.length - 1; i++) {
    const key = parts[i];
    const nextIsIndex = /^\d+$/.test(parts[i + 1]);
    if (node[key] == null) node[key] = nextIsIndex ? [] : {};
    node = node[key];
  }
  node[parts[parts.length - 1]] = value;
  return root;
}

export function deleteByPath(root, path) {
  const parts = String(path).split(".");
  let node = root;
  for (let i = 0; i < parts.length - 1; i++) {
    if (node == null) return root;
    node = node[parts[i]];
  }
  if (node) delete node[parts[parts.length - 1]];
  return root;
}
